<script>
import Multiselect from "vue-multiselect";
import * as categoryService from '../../service/category.service';

export default {
    props: {
        item_key: {
        type: String,
        required: true,
        },
        item_value: {
        type: String,
        required: false,
        },
        item: {
        type: Object,
        required: true,
        },
        submitted: {
        type: Boolean,
        required: true,
        },
        validation: {
        type: Object,
        required: true,
        },
        last_updated: {
            type: Object,
            required: false
        },
        selectedItem: {
        type: Object,
        required: false
        },
        updateValue: {
            type: Function,
            required: true
        }
    },
    components: {
        Multiselect
    },
    data() {
        return {
            value: '',
            options: [],
            d_check: this.selectedItem ? this.selectedItem[this.item.displayOn] : false
        };
    },
    computed: {
        display_none_check: {
            get: function () {
                return this.d_check;
            },
            set: function (newValue) {
                this.d_check = newValue;
            }
        }
    },
    watch: {
        last_updated: {
            handler(val) {
                if(val && this.item.displayOn && val.key == this.item.displayOn) {                    
                    this.display_none_check = JSON.stringify(val.value) == this.item.displayOnValue ? true : false;
                }
            },
            deep: true
        },
        item_value: {
            handler(val) {
                this.value = this.options.filter(x => x.url == val)[0];
            },
            deep: true
        },
        value(val) {
            if(val && val.id) {
                this.updateValue(this.item_key, val.url);
            } else {
                this.updateValue(this.item_key, '');
            }
        },
        display_none_check(val) {
            this.item.display = this.item.displayOn && !val ? false : true
        }  
    },
    methods: {
        async getOptions() {
            let filter = {
                "where": {
                "name": "Documents",
                "cmsId": this.$route.params.cmsId
                },
                "include": [
                {
                    "relation": "pages"
                }
                ]
            };

            filter = encodeURIComponent(JSON.stringify(filter));
            
            let data = await categoryService.getWithFilter(filter)
            let pages = data.length ? data[0].pages : [];
            let validFileFormats = ['application/pdf']
            this.options = pages.filter(x => validFileFormats.includes(x.additionalProp1.fileFormat))
            this.value = this.options.filter(x => x.url == this.item_value)[0]
        }
    },
    mounted() {
        this.item.display = false
        this.getOptions();
    }
};
</script>
<template>
    <div class="mb-3" :class="{ 'd-none': item.displayOn && !display_none_check}">
        <multiselect
            track-by="title"
            label="title"
            v-model="value"
            :options="options"
            :searchable="options.length > 5 ? true : false"
            :close-on-select="true"
            :show-labels="false"
            :placeholder="item.placeholder"
            :allow-empty="true"
            :preselectFirst="true"
        >
            <template slot="singleLabel" slot-scope="{option}">
                <span class="option__desc">
                    <span class="option__title">{{ option.title }}</span>
                </span>
            </template>
            <!-- <template slot="option" slot-scope="{option}">
                <img class="option__image" :src="option.url" alt="Image" style="height:5em">
                <div class="option__desc pt-3">
                    <span class="option__title">{{ option.title }}</span>
                </div>
            </template> -->
        </multiselect>
        <div v-if="submitted && validation.$error" class="invalid-feedback">
        <span v-if="!validation.required">This value is required.</span>
        </div>
    </div>
</template>
<style>
span.multiselect__option--highlight  {
    background: #b6bcc5 !important;
}
</style>